import { flatten } from "@punks/core"
import React from "react"
import { CustomBox } from "../../../../../ui/spacings"
import { expandTreeOptions } from "../../../converters/filters"
import CheckboxFilterTag from "../CheckboxFilterTag"
import { FilterCategory, CheckboxFilterOption } from "../types"

interface Props {
  filters: FilterCategory[]
  onOptionRemove?: (option: CheckboxFilterOption) => void
}

const shouldBeVisible = (
  option: CheckboxFilterOption,
  options: CheckboxFilterOption[]
) => {
  if (option.children) {
    const hasUnselectedChildren =
      option.children.find((x) => x.selected === false) !== undefined
    if (hasUnselectedChildren) {
      return false
    }
  }

  if (!option.parent) {
    return true
  }

  const peers = options.filter((x) => x.parent?.value === option.parent?.value)
  if (peers.length === 1) {
    return true
  }

  const hasUnselectedPeers =
    peers.find((x) => x.selected === false) !== undefined
  if (hasUnselectedPeers) {
    return true
  }

  return false
}

const getSelectedCheckboxFilterTags = (filters: FilterCategory) => {
  const options = expandTreeOptions(filters.options as CheckboxFilterOption[])
  const selectedOptions = options.filter((opt) => opt.selected)

  return selectedOptions
    .filter((x) => shouldBeVisible(x, options))
    .map((opt) => ({
      category: filters,
      option: opt,
    }))
}

const getSelectedCheckboxTags = (filters: FilterCategory[]) =>
  flatten(
    filters
      .filter((x) => x.type === "checkbox")
      .map((x) => getSelectedCheckboxFilterTags(x))
  )

const FilterTags = ({ filters, onOptionRemove }: Props) => {
  return (
    <CustomBox flex="row" flexWrap>
      {getSelectedCheckboxTags(filters).map((x) => (
        <div key={x.option.value} className="mb-2 mr-2">
          <CheckboxFilterTag
            option={x.option}
            category={x.category}
            onRemove={() => onOptionRemove?.(x.option)}
          />
        </div>
      ))}
    </CustomBox>
  )
}

export default FilterTags
